'use client';

import { useCallback, useEffect, useRef, useState } from 'react';

import { Loader2 } from 'lucide-react';

import { Button } from '@kit/ui/button';

interface VideoTranscriptProps {
  transcript: string;
  docId: string;
  videoUrl: string;
  onDataChange: (key: string, value: string) => void;
}

export default function VideoTranscript({
  transcript,
  videoUrl,
  docId,
  onDataChange,
}: VideoTranscriptProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleInput = useCallback(() => {
    if (!contentRef.current) return;
    const content = contentRef.current.innerHTML;
    onDataChange('transcript', content);
  }, [onDataChange]);

  useEffect(() => {
    if (contentRef.current && contentRef.current.innerText !== transcript) {
      contentRef.current.innerHTML = transcript || '';
    }
  }, [transcript]);

  const handleGenerateTranscript = async () => {
    setIsLoading(true);
    const result = await axios.get(
      `/api/summarize/youtube?url=${videoUrl}&docId=${docId}`,
    );
    onDataChange('transcript', result.data.transcript);
    setIsLoading(false);
  };

  return (
    <div className="p-4">
      {transcript ? (
        <div className="mx-auto my-10 flex w-fit flex-col gap-4">
          {transcript.map((section, index) => (
            <div key={index}>{section.text}</div>
          ))}
        </div>
      ) : (
        <div className="flex min-h-[300px] items-center justify-center text-sm">
          <Button
            variant="default"
            className="w-[180px] rounded"
            onClick={handleGenerateTranscript}
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="animate-spin" />
            ) : (
              'Transcribe Video'
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
